import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import errorLog from './modules/errorLog';
import permission from './modules/permission';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import createPersistedState from "vuex-persistedstate";
import formDesign from './modules/formDesign';
import cloneDeep from 'lodash/cloneDeep';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    app: app,
    settings: settings,
    permission: permission,
    errorLog: errorLog,
    formDesign: formDesign,
    user: user
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore: function resetStore(state) {
      Object.keys(state).forEach(function (key) {
        state[key] = cloneDeep(window.SITE_CONFIG['storeState'][key]);
      });
    }
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer: function reducer(val) {
      return {
        // 只储存state中的permission
        permission: val.permission
      };
    }
  })],
  getters: getters
});
export default store;